// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__lTjew","inputWrap":"CustomTip_inputWrap__wazl-"};